import type { BadgeTone } from '../../../ui';

/**
 * Shared task-status metadata for the Client Detail reskin.
 * Maps the app's real client_tasks statuses to design-system tones.
 */
export type PulseTone = 'up' | 'warn' | 'info' | 'down' | 'idle';

export interface TaskStatusMeta {
  tone: BadgeTone & PulseTone;
  pulse: boolean;
}

export const TASK_STATUSES = ['Scheduled', 'In Progress', 'Blocked', 'Complete', 'Submitted'] as const;

export const TASK_STATUS_META: Record<string, TaskStatusMeta> = {
  Scheduled: { tone: 'info', pulse: false },
  'In Progress': { tone: 'info', pulse: true },
  Blocked: { tone: 'down', pulse: false },
  Submitted: { tone: 'up', pulse: true },
  Complete: { tone: 'idle', pulse: false },
};

export function taskStatusMeta(status: string | null | undefined): TaskStatusMeta {
  return TASK_STATUS_META[status || ''] || { tone: 'idle', pulse: false };
}

/** Row shape used by the client task lists (subset of client_tasks). */
export interface ClientTaskRow {
  id: string;
  title: string;
  status: string;
  due_date?: string | null;
  assigned_to?: string | null;
  assigned_to_name?: string | null;
  description?: string | null;
  video_url?: string | null;
  website_id?: string;
  website_title?: string;
  archived?: boolean;
  archived_at?: string | null;
  created_at?: string;
  updated_at?: string;
  client_tasks_priority?: number | null;
  client_backlog_priority?: number | null;
}
